import React, { useState } from 'react';
import { changePassword } from '../../../services/api';
import Button from '../ui/Button';

function ChangePasswordSection() {
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [show, setShow] = useState({ current: false, next: false, confirm: false });
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const update = (field) => (event) => setForm((current) => ({ ...current, [field]: event.target.value }));
  const submit = async (event) => {
    event.preventDefault();
    setMessage('');
    if (!form.currentPassword || !form.newPassword || !form.confirmPassword) return setMessage('Please fill in all password fields.');
    if (form.newPassword !== form.confirmPassword) return setMessage('New passwords do not match.');
    setSubmitting(true);
    try {
      await changePassword(form);
      setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setMessage('Password updated successfully.');
    } catch (error) {
      setMessage(error.message || 'Unable to change password right now.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="rounded-3xl bg-white p-6 shadow-sm">
      <h2 className="text-lg font-bold uppercase tracking-wide text-navy">Change Password</h2>
      <form onSubmit={submit} className="mt-5 space-y-4">
        {[['currentPassword', 'Current password', 'current'], ['newPassword', 'New password', 'next'], ['confirmPassword', 'Confirm new password', 'confirm']].map(([field, label, key]) => (
          <label key={field} className="block text-xs font-semibold uppercase tracking-wide text-slate-600">
            {label}
            <div className="relative mt-1">
              <input type={show[key] ? 'text' : 'password'} value={form[field]} onChange={update(field)} className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 pr-14 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-navy" />
              <button type="button" onClick={() => setShow((current) => ({ ...current, [key]: !current[key] }))} className="absolute inset-y-0 right-3 text-xs font-semibold text-slate-600">{show[key] ? 'Hide' : 'Show'}</button>
            </div>
          </label>
        ))}
        <div className="flex flex-wrap items-center gap-4"><Button type="submit" variant="primary" disabled={submitting}>{submitting ? 'Updating...' : 'Change password'}</Button>{message && <p className={`text-sm ${message.includes('successfully') ? 'text-emerald-700' : 'text-rose-600'}`}>{message}</p>}</div>
      </form>
    </section>
  );
}

export default ChangePasswordSection;